import { getAttribution } from './attribution';

const OFFER_TITLE = 'أدواري — إدارة حجوزات الصالون بسهولة';
const OFFER_TEXT = 'انضم إلى أدواري واحصل على نظام حجز وإدارة مواعيد لصالونك. أول 20 مصلحة تحصل على 6 أشهر مجاناً.';

function canonicalOrigin() {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return window.location.origin;
  }
  return 'https://adwary.app';
}

export function buildOfferShareUrl(attribution = getAttribution()) {
  const url = new URL('/register-business', canonicalOrigin());
  url.searchParams.set('utm_source', 'share');
  url.searchParams.set('utm_medium', 'whatsapp');
  url.searchParams.set('utm_campaign', attribution.utm_campaign || 'first20');
  return url.toString();
}

async function copyUrl(url) {
  if (!navigator.clipboard?.writeText) return false;
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}

export async function shareOffer({
  title = OFFER_TITLE,
  text = OFFER_TEXT,
  url = buildOfferShareUrl(),
} = {}) {
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return 'shared';
    } catch (error) {
      if (error?.name === 'AbortError') return 'cancelled';
      return (await copyUrl(url)) ? 'copied' : 'unavailable';
    }
  }

  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`;
  const popup = window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  if (popup) return 'whatsapp';
  return (await copyUrl(url)) ? 'copied' : 'unavailable';
}

export { OFFER_TEXT, OFFER_TITLE };
